/**
 * NOTE:
 * WE CURRENTLY DO NOT USE THESE COLORS.
 * - Below is what we currently have in regard to revenue metrics
 *     QUESTION_EMBED,
 *     COMMENT_EMBED,
 *     STANDALONE,
 *     VIDEO,
 *     APP,
 *     ANCHOR,
 *     INTERSTITIAL,
 *     IN_STREAM_VIDEO,
 *     OUT_STREAM_VIDEO,
 *     PREBID_ADAPTER;
 *
 * @type {[{color: string, name: string, id: string},{color: string, name: string, id: string},{color: string, name: string, id: string},{color: string, name: string, id: string},{color: string, name: string, id: string},null,null,null,null,null,null,null,null,null,null]}
 */
const productTypes = [
    { id: "STANDALONE", name: "Full Ad Management", color:  '#332288'},
    { id: "COMMENT_EMBED", name: "Commenting", color: '#44aa99'},
    { id: "QUESTION_EMBED", name: "Trivia & Polls", color: '#882255'},
    { id: "TRENDING", name: "Engagement", color: '#88ccee'}, // TODO: Confirm with the BE team
    { id: "VIDEO", name: "Video Content", color: '#ddcc77'},
    { id: "APP", name: "Mobile App", color: '#70b9ff'},
    { id: "ANCHOR", name: "Anchor Ad Unit", color: '#70ffa2'},
    { id: "INTERSTITIAL", name: "Interstitial Ad Unit", color: '#ff70f3'},
    { id: "IN_STREAM_VIDEO", name: "In Stream Video", color: '#304d1d'},
    { id: "OUT_STREAM_VIDEO", name: "Out Stream Video", color: '#ff9b70'},
    { id: "PREBID_ADAPTER", name: "Prebid Adapter", color: '#2780a1'},
    { id: "OTHERS", name: "Others", color: '#779096'},
    { id: "MOBILE", name: "Mobile Web", color: '#d26c6c'},
    { id: "DESKTOP", name: "Desktop", color: '#7abb2a'},
    { id: "TOTAL", name: "Total", color: '#1494F4'},
];

const revenueTypes = {
    ANCHOR_UNIT: "Anchor Unit",
    CEU: "Content Engagement Unit",
    COMMENTING_UNIT: "Commenting",
    FAM: "Full Ad Management",
    IN_STREAM_VIDEO: "Instream Video",
    INTERSTITIAL_UNIT: "Interstitial",
    MOBILE_APP: "Mobile Apps",
    OUT_STREAM_VIDEO: "Outstream Video",
    PREBID_ADAPTER: "Prebid"
}

export { productTypes as PRODUCT_TYPES };
export { revenueTypes as REVENUE_TYPES };

export const GENDER_OPTIONS = ['MALE', 'FEMALE', 'NON_BINARY', 'NOT_SPECIFIED']

export const ANALYTICS_DETAILS_DEFAULT_DATA = { daily: {}, weekly: {}, monthly: {}, quarterly: {}}
